import React from "react";

interface MaskGradientCardProps {
    gradient?: string;
    svg?: React.ReactNode;
    image?: string;
    isThumbnail?:boolean
}

const MaskGradientCard = ({
    gradient,
    svg,
    image,
    isThumbnail=false
}: MaskGradientCardProps): JSX.Element => {
    return (
        <div className="w-full h-full flex justify-center items-center">
            <div className={`
                flex justify-center items-center relative  overflow-hidden  
                ${gradient}
                ${isThumbnail ? ' w-[74px] h-[74px] md:w-[142px] md:h-[142px] rounded-[13px] md:rounded-[20px]':'w-full h-[400px] rounded-t-[20px] lg:-mt-[6%]'}`}>
                
                <div className={`${isThumbnail ? "-mb-[36%]":"-mb-[21%] md:-mb-[37%] lg:-mb-[50%]"} top-[5.3rem] w-[140%] h-full absolute  flex justify-center items-center`}>
                    {svg}
                </div>
                <div className={`${isThumbnail? 'w-[58px] h-[58px] md:w-[110px] md:h-[110px] mt-[8%] md:mt-[12%] border-[1px] md:border-[3px]' : 'w-[clamp(220px,70vw,280px)] h-[clamp(220px,70vw,280px)] xs:w-[280px] xs:h-[280px] mt-[calc(100px-1vw)] xs:mt-[15%] lg:mt-[20%] border-[5px]'} absolute rounded-full top-0 border-solid border-white`}>
                    <img src={image} className="object-cover h-full w-full rounded-full border border-gray-100 shadow-sm" loading="lazy" />
                </div>
            </div>
        </div>
    );
};

export default MaskGradientCard;
